import { TimePickerInput } from './TimePickerInput';

interface DayScheduleRowProps {
  day: string;
  enabled: boolean;
  startTime: string;
  endTime: string;
  onEnabledChange: (enabled: boolean) => void;
  onStartTimeChange: (time: string) => void;
  onEndTimeChange: (time: string) => void;
}

export function DayScheduleRow({
  day,
  enabled,
  startTime,
  endTime,
  onEnabledChange,
  onStartTimeChange,
  onEndTimeChange,
}: DayScheduleRowProps) {
  return (
    <div className="flex items-center gap-4 px-4 py-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 transition-colors">
      <div className="w-28">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => onEnabledChange(e.target.checked)}
            className="custom-checkbox w-4 h-4 rounded border border-gray-300 bg-white hover:border-[#1875FF]/50 focus:ring-0 transition-all duration-200 cursor-pointer checked:bg-gradient-to-r checked:from-[#1875FF] checked:to-[#05E0D1] checked:border-transparent"
          />
          <span className={`text-sm font-medium ${enabled ? 'text-gray-900' : 'text-gray-400'}`}>
            {day}
          </span>
        </label>
      </div>

      {enabled ? (
        <div className="flex items-center gap-2 flex-1">
          <TimePickerInput
            value={startTime}
            onChange={onStartTimeChange}
            className="flex-1"
          />
          <span className="text-gray-400">—</span>
          <TimePickerInput
            value={endTime}
            onChange={onEndTimeChange}
            className="flex-1"
          />
        </div>
      ) : (
        <div className="flex-1">
          <span className="text-sm text-gray-400">Unavailable</span>
        </div>
      )}
    </div>
  );
}
